import React, { useEffect, Children, createElement } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Heart, BookOpen, Star, ShieldCheck } from 'lucide-react';
import { PurchaseNotification } from '../components/PurchaseNotification';
import { TestimonialCard } from '../components/TestimonialCard';
const CHECKOUT_LINK = 'https://conexao.com.ar/cart/51611313275182:1';
const customerAvatars = ['https://cdn.magicpatterns.com/uploads/bEEghGH2UopTEJdeUF6gKt/USER_Prueba_Social_1.png', 'https://cdn.magicpatterns.com/uploads/mvAY7HXBprGqXeTLBA2YxA/USER_Prueba_Social_2.jpg', 'https://cdn.magicpatterns.com/uploads/snUN34sJsuVfzCCDNct8DU/USER_Prueba_Social_3.jpg', 'https://cdn.magicpatterns.com/uploads/bd4AU3KbNPcT9vBxuxmbeV/USER_Prueba_Social_4.jpg', 'https://cdn.magicpatterns.com/uploads/puciSDZ2NwmaSZfaqzk4NB/USER_Prueba_Social_5.png'];
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
const staggerContainer = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
export function LandingPage() {
  useEffect(() => {
    // Meta Pixel Code
    ;
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    if (window.fbq) {
      window.fbq('init', '1345562017323259');
      window.fbq('track', 'PageView');
    }
  }, []);
  const scrollToPurchase = () => {
    const element = document.getElementById('purchase-section');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-white" data-id="element-20">
      {/* Meta Pixel Noscript */}
      <noscript data-id="element-21">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1345562017323259&ev=PageView&noscript=1" alt="" data-id="element-22" />
      </noscript>

      <PurchaseNotification data-id="element-23" />

      {/* Navigation */}
      <nav className="fixed top-0 w-full z-40 bg-white/95 backdrop-blur-sm border-b border-gray-200 py-3 px-4" data-id="element-24">
        <div className="max-w-6xl mx-auto flex justify-between items-center" data-id="element-25">
          <span className="font-serif font-bold text-sm text-gray-900" data-id="element-26">
            La soledad que no se nota
          </span>
          <button onClick={scrollToPurchase} className="bg-pink-600 hover:bg-pink-700 text-white px-5 py-2 rounded-full text-sm font-semibold transition-all shadow-sm hover:shadow-md" data-id="element-27">
            Acceder ahora
          </button>
        </div>
      </nav>

      {/* SECCIÓN 1: Hero - Promesa y Prueba Social */}
      <section className="pt-20 pb-12 px-4 bg-gradient-to-br from-pink-50 via-purple-50 to-pink-100 relative overflow-hidden" data-id="element-28">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(251,207,232,0.3),transparent_50%),radial-gradient(circle_at_70%_60%,rgba(233,213,255,0.3),transparent_50%)]" data-id="element-29"></div>

        <div className="max-w-5xl mx-auto relative z-10" data-id="element-30">
          {/* Social Proof - Customer Avatars */}
          <motion.div initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="flex flex-col items-center mb-6" data-id="element-31">
            <div className="flex items-center -space-x-3 mb-3" data-id="element-32">
              {customerAvatars.map((avatar, i) => <div key={i} className="w-11 h-11 rounded-full border-3 border-white shadow-md overflow-hidden" data-id="element-33">
                  <img src={avatar} alt={`Customer ${i + 1}`} className="w-full h-full object-cover" data-id="element-34" />
                </div>)}
            </div>
            <div className="flex items-center gap-2 text-sm" data-id="element-35">
              <span className="font-bold text-gray-900" data-id="element-36">+2,847 mujeres</span>
              <span className="text-gray-600" data-id="element-37">ya descargaron la guía</span>
            </div>
            <div className="flex gap-0.5 mt-1" data-id="element-38">
              {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-39" />)}
            </div>
          </motion.div>

          {/* Main Hero Content */}
          <div className="text-center max-w-4xl mx-auto" data-id="element-40">
            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2,
            duration: 0.6
          }} className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-gray-900 mb-4 leading-tight" data-id="element-41">
              La soledad que no se nota
            </motion.h1>

            {/* Book Cover - Square */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            delay: 0.3,
            duration: 0.6
          }} className="my-6 relative inline-block group cursor-pointer" onClick={scrollToPurchase} data-id="element-42">
              <div className="absolute -inset-2 bg-gradient-to-r from-pink-500 to-purple-500 rounded-xl blur-lg opacity-20 group-hover:opacity-40 transition duration-300" data-id="element-43"></div>
              <img src="https://cdn.magicpatterns.com/uploads/sgJQyEKC9jHBHA7uhkEr9h/La_soledad_que_no_se_nota.png" alt="La soledad que no se nota - Libro Digital" className="relative rounded-xl shadow-2xl w-full max-w-[320px] md:max-w-[380px] aspect-square object-cover mx-auto transform transition duration-300 group-hover:scale-[1.02]" data-id="element-44" />
            </motion.div>

            <motion.p initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.4,
            duration: 0.6
          }} className="text-xl md:text-2xl text-gray-700 italic mb-6 max-w-2xl mx-auto" data-id="element-45">
              Cuando estás acompañada, pero te sentís sola
            </motion.p>

            <motion.button initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.5,
            duration: 0.6
          }} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} onClick={scrollToPurchase} className="bg-gradient-to-r from-pink-600 to-purple-600 hover:from-pink-700 hover:to-purple-700 text-white text-lg px-8 py-4 rounded-full font-bold shadow-lg hover:shadow-xl transition-all inline-flex items-center gap-2" data-id="element-46">
              Quiero dejar de sentirme así <ArrowRight className="w-5 h-5" data-id="element-47" />
            </motion.button>
          </div>
        </div>
      </section>

      {/* SECCIÓN 2: Problema - Meter el dedo en la llaga */}
      <section className="py-16 px-4 bg-white" data-id="element-48">
        <div className="max-w-3xl mx-auto" data-id="element-49">
          <motion.div variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-50px'
        }} className="space-y-6" data-id="element-50">
            <motion.p variants={fadeIn} className="text-lg text-gray-700" data-id="element-51">
              <span className="font-semibold text-gray-900" data-id="element-52">
                Estás acompañada.
              </span>{' '}
              Tenés mensajes, conversaciones, reuniones. Tal vez incluso tenés a
              alguien al lado.
            </motion.p>

            <motion.div variants={fadeIn} className="pl-6 border-l-4 border-pink-400 italic text-gray-600 space-y-2 py-2" data-id="element-53">
              <p data-id="element-54">Y sin embargo…</p>
              <p data-id="element-55">cuando se acaban las distracciones,</p>
              <p data-id="element-56">cuando termina el día,</p>
              <p className="font-bold text-pink-700" data-id="element-57">te sentís sola.</p>
            </motion.div>

            <motion.div variants={fadeIn} className="bg-gray-50 p-6 rounded-xl space-y-3" data-id="element-58">
              <p className="text-gray-700" data-id="element-59">No querés molestar.</p>
              <p className="text-gray-700" data-id="element-60">
                No estás segura de por qué te sentís así.
              </p>
              <p className="text-gray-700" data-id="element-61">No lográs ponerle lógica.</p>
              <p className="text-xl font-serif font-bold text-gray-900 mt-4" data-id="element-62">
                El sentimiento sigue ahí y ya no sabés qué hacer.
              </p>
            </motion.div>

            <motion.div variants={fadeIn} className="text-center py-8" data-id="element-63">
              <h3 className="text-2xl font-serif text-gray-800 mb-4" data-id="element-64">
                No sabés si es angustia, depresión, agotamiento.
              </h3>
              <p className="text-3xl font-serif text-pink-700 italic mb-6" data-id="element-65">
                Es un vacío silencioso.
              </p>
              <p className="text-gray-600" data-id="element-66">
                Una soledad que no viene del abandono,{' '}
                <span className="font-bold text-gray-900" data-id="element-67">
                  sino de la desconexión.
                </span>
              </p>
            </motion.div>

            <motion.div variants={fadeIn} className="grid gap-3" data-id="element-68">
              {['Está en el medio de una risa.', 'Aparece al apoyar la cabeza en la almohada.', 'Se siente al hablar y no sentirse escuchada de verdad.', 'Es estar… sin sentirse habitada.'].map((text, i) => <div key={i} className="flex items-start gap-3 bg-pink-50 p-4 rounded-lg" data-id="element-69">
                  <div className="mt-1 min-w-[8px] h-[8px] rounded-full bg-pink-500" data-id="element-70"></div>
                  <p className="text-gray-700" data-id="element-71">{text}</p>
                </div>)}
            </motion.div>

            <motion.div variants={fadeIn} className="bg-gradient-to-br from-purple-50 to-pink-50 p-8 rounded-2xl border border-purple-100" data-id="element-72">
              <h3 className="text-2xl font-serif font-bold text-gray-900 mb-4" data-id="element-73">
                Y lo más doloroso no es sentirla. Es la culpa.
              </h3>
              <div className="space-y-3 italic text-gray-600 border-l-2 border-purple-300 pl-6" data-id="element-74">
                <p data-id="element-75">"¿Cómo puedo sentirme así si no estoy sola?"</p>
                <p data-id="element-76">"¿Qué me falta agradecer?"</p>
                <p data-id="element-77">"¿Seré demasiado sensible?"</p>
                <p data-id="element-78">"¿Será que pido demasiado?"</p>
              </div>
              <div className="text-center mt-6 pt-6 border-t border-purple-200" data-id="element-79">
                <p className="text-4xl font-serif font-bold text-pink-600 mb-3" data-id="element-80">
                  No.
                </p>
                <p className="text-lg text-gray-700" data-id="element-81">
                  No es que seas demasiado. No es que estés rota. No es que te
                  falte amor.
                </p>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* SECCIÓN 3: Solución */}
      <section className="py-16 px-4 bg-gradient-to-b from-purple-50 to-white" data-id="element-82">
        <div className="max-w-4xl mx-auto" data-id="element-83">
          {/* Presentación de Solución */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-center mb-12" data-id="element-84">
            <p className="text-sm uppercase tracking-widest text-purple-600 mb-3 font-semibold" data-id="element-85">
              Por eso creamos esto
            </p>
            <h2 className="text-3xl md:text-5xl font-serif font-bold text-gray-900 mb-3" data-id="element-86">
              La soledad que no se nota
            </h2>
            <p className="text-xl text-gray-600 italic mb-8" data-id="element-87">
              La guía que te enseña a acompañarte emocionalmente
            </p>

            <div className="bg-white p-6 rounded-2xl shadow-lg max-w-2xl mx-auto" data-id="element-88">
              <div className="space-y-3 text-left" data-id="element-89">
                <div className="flex items-center gap-3" data-id="element-90">
                  <div className="w-2 h-2 rounded-full bg-red-500" data-id="element-91"></div>
                  <p className="text-gray-700" data-id="element-92">No es un libro motivacional.</p>
                </div>
                <div className="flex items-center gap-3" data-id="element-93">
                  <div className="w-2 h-2 rounded-full bg-red-500" data-id="element-94"></div>
                  <p className="text-gray-700" data-id="element-95">No es autoayuda vacía.</p>
                </div>
                <div className="flex items-center gap-3" data-id="element-96">
                  <div className="w-2 h-2 rounded-full bg-red-500" data-id="element-97"></div>
                  <p className="text-gray-700" data-id="element-98">
                    No te dice que "no necesites a nadie".
                  </p>
                </div>
              </div>
              <div className="bg-purple-50 p-5 rounded-xl text-center mt-6" data-id="element-99">
                <p className="font-bold text-purple-900 mb-2" data-id="element-100">
                  Te enseña algo mucho más real:
                </p>
                <p className="text-lg text-gray-700" data-id="element-101">
                  Cómo acompañarte emocionalmente para poder estar con otros sin
                  perderte.
                </p>
              </div>
            </div>
          </motion.div>

          {/* Por qué funciona - 3 columnas */}
          <motion.div variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
          once: true
        }} className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-102">
            <motion.div variants={fadeIn} className="bg-white p-6 rounded-xl shadow-md" data-id="element-103">
              <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center mb-4" data-id="element-104">
                <Heart className="w-6 h-6 text-pink-600" data-id="element-105" />
              </div>
              <h3 className="font-bold text-lg text-gray-900 mb-3" data-id="element-106">
                Entendimiento profundo
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-107">
                Identificá tu tipo específico de soledad y por qué te sentís así
                incluso acompañada.
              </p>
            </motion.div>

            <motion.div variants={fadeIn} className="bg-white p-6 rounded-xl shadow-md" data-id="element-108">
              <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mb-4" data-id="element-109">
                <BookOpen className="w-6 h-6 text-purple-600" data-id="element-110" />
              </div>
              <h3 className="font-bold text-lg text-gray-900 mb-3" data-id="element-111">
                Herramientas prácticas
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-112">
                Ejercicios concretos para reconectar con tu mundo interno y
                construir compañía real.
              </p>
            </motion.div>

            <motion.div variants={fadeIn} className="bg-white p-6 rounded-xl shadow-md" data-id="element-113">
              <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center mb-4" data-id="element-114">
                <Star className="w-6 h-6 text-yellow-500" data-id="element-115" />
              </div>
              <h3 className="font-bold text-lg text-gray-900 mb-3" data-id="element-116">
                Transformación duradera
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-117">
                Aprendé a estar con otros sin abandonarte y elegir vínculos
                desde la plenitud.
              </p>
            </motion.div>
          </motion.div>

          {/* Qué vas a obtener específicamente */}
          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-2xl shadow-lg" data-id="element-118">
            <h3 className="text-2xl font-serif font-bold text-gray-900 mb-6 text-center" data-id="element-119">
              Qué vas a encontrar dentro
            </h3>
            <div className="grid gap-3" data-id="element-120">
              {['Entender por qué te sentís sola incluso cuando no lo estás', 'Identificar tu tipo de soledad invisible', 'Reconectar con tu mundo interno', 'Aprender a estar con otros sin abandonarte', 'Construir una sensación real de compañía interna'].map((item, i) => <div key={i} className="flex items-start gap-3 p-3 bg-gray-50 rounded-lg" data-id="element-121">
                  <BookOpen className="w-5 h-5 text-pink-500 flex-shrink-0 mt-0.5" data-id="element-122" />
                  <p className="text-gray-700" data-id="element-123">{item}</p>
                </div>)}
            </div>
          </motion.div>
        </div>
      </section>

      {/* SECCIÓN 4: Bonos, Oferta, Testimonios */}
      <section className="py-16 px-4 bg-gradient-to-b from-purple-900 via-purple-800 to-purple-900 text-white" data-id="element-124">
        <div className="max-w-6xl mx-auto" data-id="element-125">
          {/* Bonos */}
          <div className="text-center mb-12" data-id="element-126">
            <span className="bg-pink-500 text-white px-4 py-1.5 rounded-full text-sm font-bold tracking-wider inline-block mb-4" data-id="element-127">
              REGALO EXCLUSIVO
            </span>
            <h2 className="text-3xl md:text-4xl font-serif font-bold mb-3" data-id="element-128">
              Bonos Gratuitos
            </h2>
            <p className="text-purple-200" data-id="element-129">
              Disponibles solo hoy con tu compra
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-130">
            <motion.div initial={{
            x: -30,
            opacity: 0
          }} whileInView={{
            x: 0,
            opacity: 1
          }} viewport={{
            once: true
          }} className="bg-white/10 backdrop-blur-sm p-6 rounded-2xl" data-id="element-131">
              <img src="https://cdn.magicpatterns.com/uploads/o5Vu9xBZVifmnAWiwuh5eq/ChatGPT_Image_6_ene_2026,_02_03_02.png" alt="Test de Soledad" className="rounded-xl shadow-xl w-full mb-4" data-id="element-132" />
              <h3 className="text-xl font-bold mb-2 text-pink-300" data-id="element-133">
                Bono #1: Test de Soledad
              </h3>
              <p className="text-purple-100 text-sm" data-id="element-134">
                Descubrí exactamente qué tipo de soledad estás experimentando y
                cómo sanarla específicamente.
              </p>
            </motion.div>

            <motion.div initial={{
            x: 30,
            opacity: 0
          }} whileInView={{
            x: 0,
            opacity: 1
          }} viewport={{
            once: true
          }} className="bg-white/10 backdrop-blur-sm p-6 rounded-2xl" data-id="element-135">
              <img src="https://cdn.magicpatterns.com/uploads/65zthYQaDXwZcGhEunEfTX/ChatGPT_Image_6_ene_2026,_02_05_12.png" alt="Calendario Emocional" className="rounded-xl shadow-xl w-full mb-4" data-id="element-136" />
              <h3 className="text-xl font-bold mb-2 text-pink-300" data-id="element-137">
                Bono #2: Calendario Emocional
              </h3>
              <p className="text-purple-100 text-sm" data-id="element-138">
                Un año habitándote. Una herramienta visual para registrar y
                validar tus emociones día a día.
              </p>
            </motion.div>
          </div>

          {/* Oferta */}
          <div id="purchase-section" className="bg-white text-gray-900 rounded-3xl p-8 md:p-12 shadow-2xl max-w-4xl mx-auto mb-16" data-id="element-139">
            <div className="absolute top-0 right-0 bg-yellow-400 text-yellow-900 text-xs font-bold px-4 py-1.5 rounded-bl-xl rounded-tr-2xl uppercase tracking-wider" data-id="element-140">
              Oferta Especial
            </div>

            <div className="grid md:grid-cols-2 gap-8 items-center mb-8 mt-6" data-id="element-141">
              <div data-id="element-142">
                <img src="https://cdn.magicpatterns.com/uploads/sgJQyEKC9jHBHA7uhkEr9h/La_soledad_que_no_se_nota.png" alt="Pack Completo" className="rounded-xl shadow-lg w-full max-w-[280px] mx-auto" data-id="element-143" />
              </div>
              <div className="space-y-4" data-id="element-144">
                <h3 className="text-2xl font-bold text-gray-900" data-id="element-145">
                  La soledad que no se nota
                </h3>
                <div className="space-y-2.5" data-id="element-146">
                  <div className="flex items-center gap-3" data-id="element-147">
                    <BookOpen className="w-5 h-5 text-pink-600" data-id="element-148" />
                    <span className="text-gray-700" data-id="element-149">
                      Guía Digital Completa (PDF)
                    </span>
                  </div>
                  <div className="flex items-center gap-3" data-id="element-150">
                    <Star className="w-5 h-5 text-pink-600" data-id="element-151" />
                    <span className="text-gray-700" data-id="element-152">
                      Bono #1: Test de Soledad{' '}
                      <span className="text-green-600 text-sm font-bold" data-id="element-153">
                        GRATIS
                      </span>
                    </span>
                  </div>
                  <div className="flex items-center gap-3" data-id="element-154">
                    <Star className="w-5 h-5 text-pink-600" data-id="element-155" />
                    <span className="text-gray-700" data-id="element-156">
                      Bono #2: Calendario Emocional{' '}
                      <span className="text-green-600 text-sm font-bold" data-id="element-157">
                        GRATIS
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="border-t border-gray-200 pt-8 text-center" data-id="element-158">
              <p className="text-gray-500 line-through text-lg mb-1" data-id="element-159">$32.990</p>
              <div className="text-5xl font-bold text-pink-600 mb-6" data-id="element-160">
                $14.990{' '}
                <span className="text-xl text-gray-500 font-normal" data-id="element-161">ARS</span>
              </div>

              <motion.a href={CHECKOUT_LINK} whileHover={{
              scale: 1.03
            }} whileTap={{
              scale: 0.97
            }} className="inline-flex items-center justify-center gap-2 bg-green-500 hover:bg-green-600 text-white text-xl font-bold py-4 px-12 rounded-full shadow-lg hover:shadow-xl transition-all mb-4" data-id="element-162">
                👉 Accedé ahora a la guía
              </motion.a>

              <div className="flex items-center justify-center gap-2 text-sm text-gray-500" data-id="element-163">
                <ShieldCheck className="w-4 h-4" data-id="element-164" />
                <span data-id="element-165">Pago 100% seguro y encriptado</span>
              </div>
            </div>
          </div>

          {/* Testimonios */}
          <div className="max-w-6xl mx-auto" data-id="element-166">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-center mb-10" data-id="element-167">
              Mujeres que empezaron a habitarse
            </h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-168">
              <TestimonialCard name="Lucía" age={32} location="Buenos Aires" text="Siempre pensé que el problema era mi pareja. Leía este libro y lloraba porque me di cuenta que yo me había ido de mí misma mucho antes." delay={0} data-id="element-169" />
              <TestimonialCard name="Martina" age={28} location="Córdoba" text="Es increíble cómo describe exactamente lo que siento. Esta guía fue el abrazo que necesitaba para dejar de culparme." delay={0.1} data-id="element-170" />
              <TestimonialCard name="Sofía" age={41} location="Rosario" text="Tengo hijos, marido, trabajo, amigas. Y me sentía sola. Entender que era desconexión interna cambió todo." delay={0.2} data-id="element-171" />
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-16 px-4 bg-pink-50 text-center" data-id="element-172">
        <div className="max-w-2xl mx-auto" data-id="element-173">
          <h3 className="text-2xl font-serif font-bold text-gray-800 mb-4" data-id="element-174">
            Si esta sensación te resulta familiar
          </h3>
          <p className="text-gray-600 italic mb-6" data-id="element-175">
            Si alguna vez pensaste "no me falta gente, me falta algo adentro"…
          </p>
          <p className="font-bold text-purple-900 text-lg mb-8" data-id="element-176">
            Entonces esta guía es para vos.
          </p>
          <button onClick={scrollToPurchase} className="text-pink-600 font-bold hover:text-pink-800 underline decoration-2 underline-offset-4 transition-colors text-lg" data-id="element-177">
            Quiero mi copia ahora
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white py-6 border-t border-gray-200 text-center text-gray-500 text-sm" data-id="element-178">
        <p data-id="element-179">
          © {new Date().getFullYear()} La soledad que no se nota. Todos los
          derechos reservados.
        </p>
      </footer>
    </div>;
}